import { PropsWithChildren } from 'react'
import { WithClassName } from 'shared/types/general.types'
import { cn } from 'utils/style'

type FiltersBarProps = PropsWithChildren<WithClassName>

export const FiltersBar = ({ className, children }: FiltersBarProps) => (
	<div
		className={cn('grid grid-cols-2 gap-3 border-b border-border p-4 sm:grid-cols-4', className)}>
		{children}
	</div>
)

type FiltersBarFieldProps = PropsWithChildren<
	WithClassName<{
		label: string
	}>
>

export const FiltersBarField = ({ label, className, children }: FiltersBarFieldProps) => (
	<div className={cn('min-w-0', className)}>
		<span className="mb-1.5 block text-[11px] font-semibold text-muted-foreground">{label}</span>
		{children}
	</div>
)
